import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../api/axiosConfig';

import MapModal from '../components/MapModal'; // KakaoMap 대신 MapModal을 임포트

import icon from '../assets/chat.svg';
import icon1 from '../assets/chatList.svg';
import icon2 from '../assets/newChat.svg';
import icon3 from '../assets/chatListIcon.svg';

interface Message {
  content: string;
}

interface Session {
  _id: string;
  updatedAt: string;
  messages: Message[];
  content: string;
}

const CounselingListPage: React.FC = () => {
  const [sessions, setSessions] = useState<Session[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const [isMapModalOpen, setMapModalOpen] = useState(false);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(0);
  };

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const response = await axios.get('/api/counseling');
        console.log('Server Response:', response.data); // Log server response
        setSessions(response.data);
      } catch (error) {
        console.error('Failed to fetch counseling sessions:', error);
      }
      setIsLoading(false);
    };
    fetchSessions();
  }, []);

  const handleDelete = async (sessionId: string, e: React.MouseEvent) => {
    e.preventDefault(); // Prevent navigation
    e.stopPropagation();

    if (window.confirm('이 상담 내역을 정말 삭제하시겠습니까?')) {
      try {
        await axios.delete(`/api/counseling/${sessionId}`);
        setSessions(prevSessions => prevSessions.filter(s => s._id !== sessionId));
      } catch (error) {
        console.error('Failed to delete session:', error);
        alert('삭제에 실패했습니다.');
      }
    }
  };

  if (isLoading) {
    return <div className="app-container">Loading...</div>;
  }

  return (
    <div className=" counseling-page">
      <header className="counseling-header">
        <h1>
          <img src={icon} alt="리본상담" />
          리본상담
        </h1>
        <div>
          <button onClick={() => setMapModalOpen(true)} className="map-open-btn">
            주변 상담센터 찾기
          </button>
          <Link to="/counseling/list">
            <img src={icon1} alt="상담내역" />
          </Link>
          <div onClick={handleClick}>
            <img src={icon2} alt="새채팅" />
          </div>
        </div>
      </header>
      <div className="session-list">
        <div>
          <h1>지난 상담 내역</h1>
          <p>지난 상담 내역을 다시 확인하고 마음의 변화를 살펴보세요.</p>
        </div>
        {sessions.length > 0 ? (
          sessions.map(session => (
            <Link to={`/counseling/${session._id}`} key={session._id} className="session-item">
              <div className="session-date">
                <img src={icon3} alt="채팅 리스트" />
                <div>
                  <p>{new Date(session.updatedAt).toLocaleString()}</p>
                  <p>{`${session.messages[0].content}`}</p>
                </div>
              </div>
              <div className="session-controls">
                <button onClick={e => handleDelete(session._id, e)} className="delete-button">
                  삭제
                </button>
              </div>
            </Link>
          ))
        ) : (
          <p>아직 상담 내역이 없습니다.</p>
        )}
      </div>

      <MapModal isOpen={isMapModalOpen} onClose={() => setMapModalOpen(false)} />
    </div>
  );
};

export default CounselingListPage;
